import types from '../actions/actionTypes';


function posts( state = { 
    isFetching: false, 
    didInvalidate: false, 
    items: [] 
  }, 
  action
){ 
  switch (action.type) { 
    case types.INVALIDATE_SUBREDDIT: 
      return {
        ...state,
        didInvalidate: true 
      } 
    case types.REQUEST_POSTS: 
      return { 
        ...state,
        isFetching: true, 
        didInvalidate: false 
      } 
    case types.RECEIVE_POSTS: 
      return { 
        ...state,
        isFetching: false, 
        didInvalidate: false, 
        items: action.posts, 
        lastUpdated: action.receivedAt 
      } 
    default: 
      return state 
  }
}

export function postsBySubreddit(state = { }, action) { 
  switch (action.type) { 
    case types.INVALIDATE_SUBREDDIT: 
    case types.RECEIVE_POSTS: 
    case types.REQUEST_POSTS: 
      return {
        ...state,
        [action.subreddit]: posts(state[action.subreddit], action)
      } 
    default: 
      return state 
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/reducers/postsBySubreddit.js